import { trackDemoEvent } from "./demoTracking.js";

// デモ（TOPページ埋め込み）で共通利用する定数。
export const DEMO_SIGNUP_PATH = "/users/sign_up?from=demo";

// 本登録への遷移。モーダルの確定ボタンとフォーム下のCTAで共通利用する。
// trigger は計測用の遷移元（"cta" | "save" | "locked" | "transfer"）
export const goToDemoSignup = (trigger) => {
  trackDemoEvent("demo_signup_start", { demo_signup_trigger: trigger });
  window.location.href = DEMO_SIGNUP_PATH;
};

// デモ用PDFの生成（POST）。
export const DEMO_PDF_PATH = "/demo/skill_sheet_pdf";

// PDF生成リクエストのボディ上限。前段nginxの client_max_body_size（既定1MB）と同じ値にすること（docs/demo.md 8.9）。
export const DEMO_PDF_MAX_BODY_BYTES = 1024 * 1024;

// この index 以降のステップはデモではロック（本登録が必要）。
// ラベルとセットで更新すること。
export const DEMO_LOCKED_FROM_STEP = 9;
export const DEMO_LOCKED_FROM_STEP_LABEL = "⑩";

// 指定 index のステップがデモでロックされているか。
// demo=false（本番の作成画面）では常に false。
export const isDemoStepLocked = (demo, index) =>
  demo && index >= DEMO_LOCKED_FROM_STEP;
